<template>
<div class="common-store-list" :class="{ compact: compact, horizontal: horizontal, 'logo-only': logoOnly }">
  <div class="store-result-summary" v-if="!compact">
    <span>{{ formatSupplierCount(totalStoreCount) }} Suppliers</span>
  </div>
  <div class="storelist-body show-store-list" >
    <!-- 无限加载滚动列表 -->
    <div class="flex-wrapper" v-infinite-scroll="getMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
      <div class="ui-product-body"
           v-for='(item, index) in storeList'
           v-bind:key='index'
      >
        <div v-if="logoOnly" class="supplier-logo-card" v-on:click='goDetail(item.store_id)'>
          <div class="supplier-logo-image">
            <img v-lazy="getLogoImage(item)">
          </div>
          <div class="supplier-logo-name">{{ item.store_name }}</div>
        </div>
        <div v-else class="supplier-result-card" v-on:click='goDetail(item.store_id)'>
          <div class="supplier-head">
            <div class="supplier-avatar">
              <img v-lazy="item.store_avatar">
            </div>
            <div class="supplier-content">
              <h3>{{ item.store_name }}</h3>
              <div class="supplier-meta">
                <span class="stars" v-if="getStoreRating(item)">{{ getStoreRating(item) }} ★★★★★</span>
              </div>
              <div class="supplier-cert" v-if="item.store_keywords || item.store_description">
                {{ item.store_keywords || item.store_description }}
              </div>
            </div>
          </div>
          <div class="supplier-goods" v-if="item.goods_list && item.goods_list.length">
            <div class="supplier-goods-item" v-for="(goods,gindex) in item.goods_list.slice(0, 3)" :key="gindex" @click.stop="goGoods(goods.goods_id)">
              <div class="supplier-goods-image"><img :src="goods.goods_image_url || goods.goods_img_480 || goods.goods_image_format"></div>
              <div class="supplier-goods-name">{{ goods.goods_name }}</div>
              <div class="supplier-goods-price">${{ goods.goods_promotion_price || goods.goods_price }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-wrapper" v-if="storeList.length > 0">
        <p class="common-no-more" v-if='!isMore'>No more</p>
        <mt-spinner type="triple-bounce" color='#e93b3d' v-if='isMore'></mt-spinner>
      </div>
      <empty-record v-if='storeList.length <= 0 && !isMore'></empty-record>
    </div>
  </div>
</div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui'
import EmptyRecord from '../../EmptyRecord'
import { mapState } from 'vuex'
import { getStoreList, getStoreNearbyList, searchGoodsList } from '../../../api/homesearch'
import { getStoreInfo } from '../../../api/homestoredetail'
export default {
  name: 'CommonStoreList',
  props: {
    keyword: {
      type: String,
      default: ''
    },
    sortKey: {
      type: String,
      default: ''
    },
    category: {
      type: [String, Number],
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 0
    },
    onlyWithGoods: {
      type: Boolean,
      default: false
    },
    logoOnly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EmptyRecord
  },
  data () {
    return {
      sortkey: [
        {
          key: '',
          name: 'Relevance',
          isMore: true,
          id: 0,
          child: [
            {
              key: '',
              name: 'Relevance',
              isMore: false,
              id: 3
            },
            {
              key: 'distance',
              name: 'Distance',
              isMore: false,
              id: 4
            }
          ]
        },
        {
          key: 'store_sales',
          name: 'Sales',
          isMore: false,
          id: 1
        },
        {
          key: 'store_credit',
          name: 'Highest rated',
          isMore: false,
          id: 2
        }
      ], // 排序数据
      currentSortKey: {}, // 当前选中的排序
      childSort: [], // 综合筛选
      sort: {}, // 综合筛选子集
      isShowMore: false, // 是否显示筛选模态框
      params: {
        brand: this.$route.query.brand ? this.$route.query.brand : '',
        category: this.category || (this.$route.query.storeclass_id ? this.$route.query.storeclass_id : ''),
        is_exchange: 0,
        is_hot: 0,
        activity: null, // TODO: 确认activity的值
        sort_key: this.sortKey || (this.$route.query.sort_key ? this.$route.query.sort_key : ''),
        sort_value: 2,
        page: 0,
        keyword: this.keyword || (this.$route.query.keywords ? this.$route.query.keywords : ''),
        only_with_goods: this.onlyWithGoods ? 1 : 0
      },
      storeList: [], // 商品列表
      storeInfoCache: {},
      storeInfoRequests: {},
      totalStoreCount: 0,
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  computed: {
    ...mapState({
      member_point: state => state.member.point,
      token: state => state.member.token
    })
  },
  created () {
    this.currentSortKey = this.sortkey[0]
    this.childSort = this.currentSortKey.child
    this.sort = this.childSort[0]
  },
  watch: {
    keyword (value) {
      if (value !== this.params.keyword) {
        this.searchByKeyword(value)
      }
    }
  },
  methods: {
    formatSupplierCount (count) {
      const total = Number(count) || 0
      if (total < 10) return total
      const magnitude = Math.pow(10, String(Math.floor(total)).length - 1)
      return Math.floor(total / magnitude) * magnitude + '+'
    },
    searchByKeyword (keyword) {
      this.params.keyword = keyword
      this.params.page = 0
      this.storeList = []
      this.totalStoreCount = 0
      this.loading = false
      this.isMore = true
      this.getMore()
    },
    getStoreRating (store) {
      let credit = store.store_credit || {}
      let scores = [
        credit.store_desccredit && credit.store_desccredit.credit,
        credit.store_servicecredit && credit.store_servicecredit.credit,
        credit.store_deliverycredit && credit.store_deliverycredit.credit
      ].map(score => parseFloat(score)).filter(score => !isNaN(score))
      if (!scores.length && store.store_credit_percent) {
        return (parseFloat(store.store_credit_percent) / 20).toFixed(1)
      }
      if (!scores.length) return ''
      return (scores.reduce((total, score) => total + score, 0) / scores.length).toFixed(1)
    },
    getLogoImage (store) {
      const storeAvatar = store.img_store_avatar || store.store_avatar || ''
      if (storeAvatar && storeAvatar.indexOf('default_store_avatar') === -1) return storeAvatar
      const goods = store.goods_list && store.goods_list[0]
      return goods ? (goods.goods_image_url || goods.goods_img_480 || goods.goods_image_format) : storeAvatar
    },
    getStoreDetails (storeId) {
      if (this.storeInfoCache[storeId]) {
        return Promise.resolve(this.storeInfoCache[storeId])
      }
      if (this.storeInfoRequests[storeId]) {
        return this.storeInfoRequests[storeId]
      }
      const request = getStoreInfo(storeId, this.token).then(storeRes => {
        const storeInfo = storeRes.result && storeRes.result.store_info ? storeRes.result.store_info : {}
        this.$set(this.storeInfoCache, storeId, storeInfo)
        this.$delete(this.storeInfoRequests, storeId)
        return storeInfo
      }).catch(error => {
        this.$delete(this.storeInfoRequests, storeId)
        throw error
      })
      this.$set(this.storeInfoRequests, storeId, request)
      return request
    },
    // closeFiler: 关闭下拉筛选模态框
    closeFiler () {
      this.isShowMore = false
    },
    // isShowDroupMenu: 点击显示下拉框， 并且显示模态框
    isShowDroupMenu () {
      let item = this.currentSortKey
      if (item.isMore) {
        this.isShowMore = true
      } else {
        this.isShowMore = false
      }
    },
    /**
     *  setActiveSortkey: 点击切换数据并设置选中的样式
     *  @param: item 当前选中的item
     */
    setActiveSortkey (item, index) {
      this.currentSortKey = item

      if (item.isMore) {
        this.isShowMore = !this.isShowMore
      } else {
        this.closeFiler()
        this.getValue()
      }
    },
    /**
     *  getValue: 向父级组件发送改变列表事件， 并传递当前的sort_key， sort_value
     */
    getValue () {
      let data = this.getSortValue()
      let res = data
      this.params.page = 1
      this.storeList = []
      this.totalStoreCount = 0
      this.loading = false
      this.setParamsByData(res)
      if (data.sort_key == 'distance') {
        if (!this.member_point.lng || !this.member_point.lat) {
          MessageBox.confirm('We need to get your location information first', '', { cancelButtonText: 'Refuse', confirmButtonText: 'Agree' }).then(action => {
            this.$router.push({ name: 'HomeMap' })
          }).catch(function (error) {

          })
        } else {
          this.getStoreList(false, true)
        }
      } else {
        this.getStoreList()
      }
    },
    /**
     *  getSortValue: 获取排序值
     */
    getSortValue () {
      let sort = this.currentSortKey
      let value = { 'sort_key': '', 'sort_value': '' }
      if (sort.isMore) {
        value.sort_key = this.sort.key
      } else {
        value.sort_key = sort.key
      }
      return value
    },
    /**
     *  getSortChild: 获取综合筛选的子集， 关闭父级的阴影模态框， 关闭子集， 获取列表数据
     *  @param: item 模态框的item
     */
    getSortChild (item) {
      this.sort = item
      this.isShowMore = !this.isShowMore
      this.getValue()
    },
    /*
    * getMore: 无限滚动加载
    */
    getMore () {
      if (this.loading || !this.isMore) return
      this.loading = true
      this.params.page = ++this.params.page
      this.getStoreList(true)
    },
    /**
     * getStoreList: 获取商品列表
     * @param：  ispush ？ true ：false 是否需要向商品列表追加数据
     */
    getStoreList (ispush = false, nearby = false) {
      let data = this.params
      if (data.keyword && !nearby) {
        this.getStoresByProductKeyword(ispush)
        return
      }
      const request = nearby
        ? getStoreNearbyList(
          data.brand,
          data.category,
          data.keyword,
          this.member_point.lng,
          this.member_point.lat,
          data.sort_key,
          data.page,
          this.token
        )
        : getStoreList(
          data.brand,
          data.category,
          data.keyword,
          0,
          0,
          data.sort_key,
          data.page,
          data.only_with_goods,
          this.token
        )
      request.then(res => {
        this.buildData(ispush, res)
      }).catch(() => {
        if (!ispush) this.storeList = []
        this.isMore = false
      }).then(() => {
        this.loading = false
      })
    },
    getStoresByProductKeyword (ispush) {
      searchGoodsList({
        keyword: this.params.keyword,
        sort_key: 'goods_salenum',
        page: this.params.page
      }, this.token).then(res => {
        let goodsList = res.result && res.result.goods_list ? res.result.goods_list : []
        let groupedStores = []
        goodsList.forEach(goods => {
          let storeId = goods.store_id
          if (!storeId) return
          let group = groupedStores.find(store => store.store_id === storeId)
          if (!group) {
            group = {
              store_id: storeId,
              store_name: goods.store_name,
              is_platform_store: goods.is_platform_store,
              goods_list: []
            }
            groupedStores.push(group)
          }
          group.goods_list.push(goods)
        })

        Promise.all(groupedStores.map(group => this.getStoreDetails(group.store_id)
          .then(storeInfo => Object.assign({}, storeInfo, group, { goods_list: group.goods_list }))
          .catch(() => group)))
          .then(stores => {
            let nextStores = ispush ? this.storeList.slice() : []
            stores.forEach(store => {
              let existing = nextStores.find(item => item.store_id === store.store_id)
              if (existing) {
                let existingIds = existing.goods_list.map(goods => goods.goods_id)
                existing.goods_list = existing.goods_list.concat(
                  store.goods_list.filter(goods => existingIds.indexOf(goods.goods_id) < 0)
                )
              } else {
                nextStores.push(store)
              }
            })
            this.storeList = nextStores
            this.totalStoreCount = Number(res.result && res.result.store_count) || 0
            this.isMore = !!(res.result && res.result.hasmore)
          })
      }).catch(() => {
        if (!ispush) {
          this.storeList = []
        }
        this.isMore = false
      }).then(() => {
        this.loading = false
      })
    },
    /**
     * getList: 构建数据
     * @param: ispush 是否改变向元数据追加数据
     * @param: res 接口请求返回的数据
     */
    buildData (ispush, res) {
      if (res) {
        const rawStores = res.result && Array.isArray(res.result.store_list) ? res.result.store_list : []
        const stores = rawStores.map(store => {
          const primaryGoods = Array.isArray(store.goods_list) ? store.goods_list : []
          const searchableGoods = Array.isArray(store.search_list_goods) ? store.search_list_goods : []
          const goodsMap = {}
          primaryGoods.concat(searchableGoods).forEach(goods => {
            if (goods && goods.goods_id) {
              goodsMap[goods.goods_id] = Object.assign({}, goodsMap[goods.goods_id], goods)
            }
          })
          const goodsList = Object.keys(goodsMap).map(id => goodsMap[id]).filter(goods => {
            return goods.goods_image_url || goods.goods_img_480 || goods.goods_image_format
          })
          return Object.assign({}, store, { goods_list: goodsList })
        }).filter(store => !this.onlyWithGoods || store.goods_list.length > 0)
        const nextStores = ispush ? this.storeList.concat(stores) : stores
        const uniqueStores = nextStores.filter((store, index, list) => {
          return list.findIndex(item => item.store_id === store.store_id) === index
        })
        this.storeList = this.limit ? uniqueStores.slice(0, this.limit) : uniqueStores
        this.totalStoreCount = Number(res.result && res.result.store_count) || 0
        this.isMore = this.limit ? false : res.result.hasmore
      }
    },
    /**
     * 根据事件传递的值来对请求列表重新赋值
     * @param data 事件传递的参数
     * @returns {params|{brand, category, is_exchange, is_hot, activity, sort_key, sort_value, page, per_page, keyword}}
     */
    setParamsByData (data) {
      let params = this.params
      for (let item in params) {
        for (let list in data) {
          if (item === list) {
            params[item] = data[list]
          }
        }
      }
      return params
    },
    goDetail (store_id) {
      this.$router.push({ 'name': 'HomeStoredetail', 'query': { 'id': store_id } })
    },
    goGoods (goods_id) {
      if (goods_id) {
        this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: goods_id } })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .ui-product-body {

    .goods-list{padding:.8rem .5rem;border-top:1px solid #e1e1e1;overflow: hidden;background:#fff;
      .goods-item{float:left;width:25%;text-align: center;
        .goods-image2 {
          margin-bottom:.2rem;
          img{width:3.5rem;height: 3.5rem;}
        }
        .goods-price{color:$primaryColor;font-size:.7rem;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;width:100%}
      }
    }
    .list-wrapper{margin-bottom:.5rem;}
  .list {
    display: flex;
    width: auto;
    align-items: center;
    justify-content: space-between;
    padding:0.5rem;
    position: relative;
    background:#fff;

  div.ui-image-wrapper {
    width: 3rem;
    height: 3rem;
    position: relative;
    border:1px solid #e1e1e1;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-basis: 3rem;
    flex-shrink: 0;

    background-position:center center!important;
    background-size:5rem 5rem;
    background-repeat:no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

  img.product-img{
    width: 3rem;
    height: 3rem;
    flex-basis: 3rem;
    flex-shrink: 0;
  }

  .store-result-summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 2rem;
    padding: 0 0.65rem;
    background: #f5f7f9;
    color: #55718b;
    font-size: 0.62rem;
    box-sizing: border-box;
  }
  .store-result-summary button {
    height: 1.5rem;
    padding: 0 0.65rem;
    border: 1px solid #aeb6bf;
    border-radius: 0.8rem;
    background: #fff;
    color: #333;
    font-size: 0.62rem;
  }
  .store-result-summary button i {
    margin-right: 0.2rem;
    color: #38434d;
  }
  .supplier-result-card {
    padding: 0.7rem 0.65rem 0.75rem;
    border-bottom: 1px solid #e5e7e9;
    background: #fff;
    box-sizing: border-box;
  }
  .supplier-head {
    display: flex;
    align-items: flex-start;
    min-height: 3.05rem;
  }
  .supplier-avatar {
    width: 2.55rem;
    height: 2.55rem;
    margin-right: 0.6rem;
    border: 1px solid #e3e5e8;
    border-radius: 0.25rem;
    background: #fafafa;
    overflow: hidden;
    flex-shrink: 0;
  }
  .supplier-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .supplier-content {
    min-width: 0;
    flex: 1;
  }
  .supplier-content h3 {
    margin: 0 0 0.25rem;
    color: #202124;
    font-size: 0.74rem;
    line-height: 0.95rem;
    font-weight: 700;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .supplier-meta,
  .supplier-cert {
    display: flex;
    align-items: center;
    min-width: 0;
    overflow: hidden;
    color: #68717a;
    font-size: 0.58rem;
    line-height: 0.8rem;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .supplier-meta > span {
    margin-right: 0.35rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .supplier-meta .audited {
    color: #365d9d;
    font-weight: 700;
  }
  .supplier-meta .stars {
    color: #e7a36f;
    letter-spacing: 0;
  }
  .supplier-cert {
    display: block;
    margin-top: 0.1rem;
  }
  .supplier-goods {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.55rem;
    margin-top: 0.65rem;
  }
  .supplier-goods-item {
    min-width: 0;
    cursor: pointer;
  }
  .supplier-goods-image {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 0.35rem;
    background: #f4f5f6;
    overflow: hidden;
  }
  .supplier-goods-image img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .supplier-goods-price {
    margin-top: 0.28rem;
    color: #202124;
    font-size: 0.72rem;
    line-height: 0.9rem;
    font-weight: 700;
  }
  .common-store-list.compact {
    background: #fff;
  }
  .common-store-list.compact .supplier-result-card {
    padding: 0.7rem 0.55rem 0.8rem;
  }
  .common-store-list.compact .supplier-goods {
    gap: 0.38rem;
    margin-top: 0.6rem;
  }

  span {
    position: absolute;
    height:1rem;
    background:rgba(243,244,245,1);
    line-height: 1rem;
    text-align: center;
    font-size:0.7rem;
    color:#e93b3d;
    width: 5.5rem;
    bottom: 0;
    left: 0;
  }
  }
  .flex-right {
    padding-top:.5rem;
    padding-left: 0.7rem;
    width: 100%;
    position:relative;
  .title {
    color: #333;
    font-size: 0.7rem;
    font-weight: normal;

    display:-moz-box;
    display:-webkit-box;

    -webkit-line-clamp: 2;
    -moz-line-clamp: 2;

    -moz-box-orient:vertical;
    -webkit-box-orient:vertical;
    box-orient:vertical;

    overflow: hidden;
    margin-bottom: 0.4rem;
  &.clear-bottom {
     margin-bottom: 0;
   }
  }
.store-info-wrapper{display: flex;
  .store-info{flex:1}
  .btn{
    float:right;
    max-width:4rem;
    padding:0 0.5rem;
    font-size:.7rem;
    color:#e1e1e1;
    text-align: center;
    border:1px solid #e1e1e1;
    border-radius:1rem;
    height: 1rem;
    line-height: 1rem;
  }
  .btn.active{border-color:$primaryColor;background:$primaryColor;color:#fff}
  .distance{font-size:.7rem;color:#999}
}
  .product-header {
    display: flex;
    align-items: center;
  }
    .collect-info{font-size:.6rem;color:#999}
  .sub-title {
    color: #55595F;
    font-size: .7rem;

    display:-moz-box;
    display:-webkit-box;

    -webkit-line-clamp: 1;
    -moz-line-clamp: 1;

    -moz-box-orient:vertical;
    -webkit-box-orient:vertical;
    box-orient:vertical;

    overflow: hidden;
    margin-bottom: 0.4rem;
  }
  .price {
    margin-bottom: 0.4rem;
  span {
  &:first-child {
     color: #e93b3d;
     font-size: 0.8rem;
   }
  &:last-child {
     color: #A4AAB3;
     font-size: 0.6rem;
     text-decoration: line-through;
   }
  }
  }
  .sendway {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.6rem;
    font-weight: 'Regular';
  span{
    color: #7C7F88;
  &.self-support {
     font-size: 0.5rem;
     color: #e93b3d;
     border: 1px solid #e93b3d;
     border-radius: 0.1rem;
     width: 1.6rem;
     height: 0.8rem;
     line-height: 0.8rem;
     text-align: center;
   }
  }
  }
  }
  }
  }
.store-result-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 2rem;
  padding: 0 0.65rem;
  background: #f5f7f9;
  color: #55718b;
  font-size: 0.62rem;
  box-sizing: border-box;
}
.store-result-summary button {
  height: 1.5rem;
  padding: 0 0.65rem;
  border: 1px solid #aeb6bf;
  border-radius: 0.8rem;
  background: #fff;
  color: #333;
  font-size: 0.62rem;
}
.store-result-summary button i {
  margin-right: 0.2rem;
  color: #38434d;
}
.supplier-result-card {
  padding: 0.7rem 0.65rem 0.75rem;
  border-bottom: 1px solid #e5e7e9;
  background: #fff;
  box-sizing: border-box;
}
.supplier-head {
  display: flex;
  align-items: flex-start;
  min-height: 3.05rem;
}
.supplier-avatar {
  width: 2.55rem;
  height: 2.55rem;
  margin-right: 0.6rem;
  border: 1px solid #e3e5e8;
  border-radius: 0.25rem;
  background: #fafafa;
  overflow: hidden;
  flex-shrink: 0;
}
.supplier-avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.supplier-content {
  min-width: 0;
  flex: 1;
}
.supplier-content h3 {
  margin: 0 0 0.25rem;
  color: #202124;
  font-size: 0.74rem;
  line-height: 0.95rem;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.supplier-meta,
.supplier-cert {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  color: #68717a;
  font-size: 0.58rem;
  line-height: 0.8rem;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.supplier-meta > span {
  margin-right: 0.35rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.supplier-meta .audited {
  color: #365d9d;
  font-weight: 700;
}
.supplier-meta .stars {
  color: #e7a36f;
  letter-spacing: 0;
}
.supplier-cert {
  display: block;
  margin-top: 0.1rem;
}
.supplier-goods {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem;
  margin-top: 0.65rem;
}
.supplier-goods-item {
  min-width: 0;
  cursor: pointer;
}
.supplier-goods-image {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 0.35rem;
  background: #f4f5f6;
  overflow: hidden;
}
.supplier-goods-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.supplier-goods-name {
  display: -webkit-box;
  min-height: 1.5rem;
  margin-top: 0.25rem;
  color: #3e464d;
  font-size: 0.58rem;
  line-height: 0.75rem;
  overflow: hidden;
  overflow-wrap: anywhere;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.common-store-list.compact .storelist-body {
  background: #fff;
}
.common-store-list.compact .supplier-result-card {
  padding: 0.55rem 0.55rem 0.7rem;
  border-bottom: 1px solid #eef0f2;
}
.common-store-list.compact .supplier-head {
  min-height: 2.65rem;
}
.common-store-list.compact .supplier-avatar {
  width: 2.4rem;
  height: 2.4rem;
  margin-right: 0.5rem;
}
.common-store-list.compact .supplier-content h3 {
  margin-bottom: 0.18rem;
  font-size: 0.78rem;
  line-height: 0.95rem;
}
.common-store-list.compact .supplier-meta,
.common-store-list.compact .supplier-cert {
  font-size: 0.6rem;
  line-height: 0.78rem;
}
.common-store-list.compact .supplier-goods {
  gap: 0.35rem;
  margin-top: 0.45rem;
}
.common-store-list.compact .supplier-goods-image {
  border-radius: 0.3rem;
}
.common-store-list.compact .supplier-goods-image img {
  object-fit: contain;
}
.common-store-list.compact .supplier-goods-price {
  margin-top: 0.22rem;
  color: #202124;
  font-size: 0.76rem;
  line-height: 0.9rem;
  font-weight: 700;
  white-space: nowrap;
}
.common-store-list.horizontal .storelist-body {
  overflow: hidden;
}
.common-store-list.horizontal .flex-wrapper {
  display: flex;
  gap: 0.45rem;
  padding: 0 0.55rem 0.2rem;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.common-store-list.horizontal .flex-wrapper::-webkit-scrollbar {
  display: none;
}
.common-store-list.horizontal .ui-product-body {
  width: 12rem;
  min-width: 12rem;
}
.common-store-list.horizontal .supplier-result-card {
  border: 1px solid #edf0f2;
  border-radius: 0.3rem;
}
.common-store-list.horizontal .loading-wrapper,
.common-store-list.horizontal .common-no-more {
  display: none;
}
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 1.7rem;
}
.loading-wrapper .common-no-more {
  width: 100%;
  margin: 0;
  text-align: center;
}
.common-store-list.logo-only .ui-product-body {
  width: 7.1rem;
  min-width: 7.1rem;
}
.supplier-logo-card {
  padding: 0.35rem 0.35rem 0.55rem;
  border: 1px solid #edf0f2;
  border-radius: 0.25rem;
  background: #fff;
  box-sizing: border-box;
  cursor: pointer;
}
.supplier-logo-image {
  width: 100%;
  height: 6.25rem;
  overflow: hidden;
  border-radius: 0.18rem;
  background: #fff;
}
.supplier-logo-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.supplier-logo-name {
  display: -webkit-box;
  min-height: 1.5rem;
  margin-top: 0.35rem;
  padding: 0 0.12rem;
  color: #202124;
  font-size: 0.62rem;
  line-height: 0.78rem;
  font-weight: 700;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
